import { render } from "./MyClosedOrders.vue?vue&type=template&id=7ae9c0c0"
import script from "./MyClosedOrders.vue?vue&type=script&lang=js"
export * from "./MyClosedOrders.vue?vue&type=script&lang=js"

import "./MyClosedOrders.vue?vue&type=style&index=0&id=7ae9c0c0&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__